<p-table
  [value]="this.statusService.filteredStatus"
  showGridlines
>
  <ng-template #header>
    <tr>
      <th>Status</th>
      <th>Nutzer</th>
      <th>Start</th>
      <th>Ende</th>
      <th>Nachrichten</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-status
    let-ri="rowIndex"
  >
    <tr>
      <td>
        @if(this.isSessionRunning(status.endDate)){
        <i
          class="pi pi-circle-on cursor-pointer"
          style="color: var(--p-green-500)"
        ></i>
        } @else {
        <i
          class="pi pi-circle-on cursor-pointer"
          style="color: var(--p-red-500)"
        ></i>
        }
      </td>
      <td>{{ status.userId }}</td>
      <td>{{ status.startDate | date: "dd.MM.yyyy&nbsp;HH:mm:ss" }}</td>
      <td>{{ status.endDate| date: "dd.MM.yyyy&nbsp;HH:mm:ss" }}</td>
      <td>{{ status.chatHistoryItems.length}}</td>
      <td>
        <div class="text-right pe-5">
          <i
            class="pi pi-ellipsis-h cursor-pointer"
            (click)="this.onContextMenu($event, status._id)"
          ></i>
          <p-contextmenu
            #cm
            appendTo="body"
          />
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<app-session-details></app-session-details>

<p-confirmdialog />